import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {
  Row,
  Col,
  Label,
  FormGroup,
  InputGroup,
  InputGroupAddon,
  Input,
  Card
} from 'reactstrap';

import Button from '../Button';
import SortableTable from '../SortableTable';
import Form from '../Form';
import MoneyInput from '../MoneyInput';
import MoneyDisplay from '../MoneyDisplay';

import {
  ADJOY_DEFAULT_CHOOSE_COST,
  ADJOY_DEFAULT_THIS_OR_THAT_COST,
  ADJOY_DEFAULT_RATABLE_COST,
  ADJOY_DEFAULT_QA_COST,
  ADJOY_DEFAULT_REVENUE_SPLIT
} from '../../../config';

import { roundUpToNearestCent } from '../..//utils';

class SpecialPricingForm extends Component {
  componentWillMount(){
    const {
      defaultRevenueSplit,
      ratableDefaultCost,
      chooseDefaultCost,
      qaDefaultCost,
      thisOrThatDefaultCost,
      defaultCostPerCompletion,
      useCostPerCompletion
    } = this.props;

    if(defaultRevenueSplit === 0 || defaultRevenueSplit){
      this.setState({revenueSplit:defaultRevenueSplit});
    } else {
      this.setState({revenueSplit:ADJOY_DEFAULT_REVENUE_SPLIT})
    }

    if(ratableDefaultCost === 0 || ratableDefaultCost){
      this.setState({ratablePrice:ratableDefaultCost});
    } else {
      this.setState({ratablePrice:ADJOY_DEFAULT_RATABLE_COST});
    }

    if(chooseDefaultCost === 0 || chooseDefaultCost){
      this.setState({choosePrice:chooseDefaultCost});
    } else {
      this.setState({choosePrice:ADJOY_DEFAULT_CHOOSE_COST})
    }

    if(qaDefaultCost === 0 || qaDefaultCost){
      this.setState({qaPrice:qaDefaultCost})
    } else {
      this.setState({qaPrice:ADJOY_DEFAULT_QA_COST})
    }

    if(thisOrThatDefaultCost === 0 || thisOrThatDefaultCost){
      this.setState({thisOrThatPrice:thisOrThatDefaultCost});
    } else {
      this.setState({thisOrThatPrice:ADJOY_DEFAULT_THIS_OR_THAT_COST})
    }

    if(defaultCostPerCompletion === 0 || defaultCostPerCompletion){
      this.setState({costPerCompletion:defaultCostPerCompletion})
    } else {
      this.setState({costPerCompletion:0});
    }

    if(useCostPerCompletion){
      this.setState({useCostPerCompletion:true});
    }
  }

  handleSubmit(data){
    const changes = {};

    const {
      revenueSplit,
      choosePrice,
      thisOrThatPrice,
      ratablePrice,
      qaPrice,
      propagateCostChanges,
      costPerCompletion
    } = data;

    const {
      defaultDefaultRevenueSplit,
      defaultChooseDefaultCost,
      defaultThisOrThatDefaultCost,
      defaultRatableDefaultCost,
      defaultQADefaultCost,
      forceUpdate
    } = this.props;

    const {
      useCostPerCompletion
    } = this.state;

    if(parseInt(revenueSplit,10) !== parseInt(defaultDefaultRevenueSplit * 100,10) || forceUpdate){
      changes.revenueSplit = parseInt(revenueSplit,10) / 100;
    }

    if(parseFloat(costPerCompletion) && useCostPerCompletion){
      changes.useCostPerCompletion = true;
      changes.defaultCostPerCompletion = parseFloat(costPerCompletion);

    } else {

      if(parseFloat(choosePrice) !== parseFloat(defaultChooseDefaultCost) || forceUpdate){
        changes.chooseDefaultCost = parseFloat(choosePrice);
      }

      if(parseFloat(thisOrThatPrice) !== parseFloat(defaultThisOrThatDefaultCost)|| forceUpdate){
        changes.thisOrThatDefaultCost = parseFloat(thisOrThatPrice);
      }

      if(parseFloat(ratablePrice) !== parseFloat(defaultRatableDefaultCost)|| forceUpdate){
        changes.ratableDefaultCost = parseFloat(ratablePrice);
      }

      if(parseFloat(qaPrice) !== parseFloat(defaultQADefaultCost)|| forceUpdate){
        changes.qaDefaultCost = parseFloat(qaPrice);
      }

      changes.useCostPerCompletion = false;
    }

    changes.propagateCostChanges = !!(propagateCostChanges && propagateCostChanges === 'on');

    this.props.onSubmit(changes);
    this.props.onChange(changes);
  }

  render(){
    const {
      defaultDefaultRevenueSplit,
      defaultChooseDefaultCost,
      defaultThisOrThatDefaultCost,
      defaultRatableDefaultCost,
      defaultQADefaultCost,
      updateButtonText,
      readOnly,
      readOnlyMessage,
      allowPropagation,
      propagationCheckboxText
    } = this.props;

    const {
      ratablePrice,
      thisOrThatPrice,
      choosePrice,
      revenueSplit,
      qaPrice,
      costPerCompletion,
      useCostPerCompletion
    } = this.state;

    return (
      <Form onSubmit={(data) => this.handleSubmit(data)}>
        <Row>
          <Col xs='4' md='6'>
            <br />
            <br />
            <h6>
              Revenue Split&nbsp;&nbsp;&nbsp;<strong>(Default: Consumer gets %{(defaultDefaultRevenueSplit * 100)})</strong>
            </h6>
            <FormGroup check>
              <Label check>
                <Input
                  type='checkbox'
                  checked={useCostPerCompletion}
                  onClick={(e) => this.setState({useCostPerCompletion:e.target.checked})}
                />
                &nbsp;&nbsp;Use cost per completion pricing
              </Label>
            </FormGroup>
          </Col>
          <Col xs='4' md='3'>
            <FormGroup>
              <Label>Consumer</Label>
              <InputGroup>
                <InputGroupAddon 
                  addonType='prepend'
                  style={{backgroundColor:'transparent'}}
                >
                  %
                </InputGroupAddon>
                <Input
                  name='revenueSplit'
                  type='number'
                  value={(revenueSplit * 100).toFixed(0)}
                  onChange={(e) => this.setState({revenueSplit:parseInt(e.target.value,10) / 100})}
                  step='1'
                  min='0'
                  max='100'
                  required
                  readOnly={readOnly}
                />
              </InputGroup>
            </FormGroup>
          </Col>
          <Col xs='4' md='3'>
            <FormGroup>
              <Label>Dabbl</Label>
              <InputGroup>
                <InputGroupAddon 
                  addonType='prepend'
                  style={{backgroundColor:'transparent'}}
                >
                  %
                </InputGroupAddon>
                <Input
                  type='number'
                  value={((1 - revenueSplit) * 100).toFixed(0)}
                  onChange={(e) => this.setState({revenueSplit:parseInt(100 - e.target.value,10) / 100})}
                  step='1'
                  min='0'
                  max='100'
                  required
                  readOnly={readOnly}
                />
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>
        <br />
        <br />
        <Card style={{opacity:useCostPerCompletion ? 1 : 0.5}}>
          <SortableTable columns={[
              {name:' ',width:30},
              {name:' ',width:30},
              {name:'Consumer Gets',width:20},
              {name:'Dabbl Gets',width:20}
            ]}>
            <tr>
              <td>Cost Per Completion</td>
              <td>
                <MoneyInput
                  name='costPerCompletion'
                  value={costPerCompletion}
                  disabled={!useCostPerCompletion}
                  onChange={(val) => this.setState({costPerCompletion:val})}
                />
              </td>
              <td>
                <strong>
                  <MoneyDisplay>
                    {roundUpToNearestCent(revenueSplit * costPerCompletion)}
                  </MoneyDisplay>
                </strong>
              </td>
              <td>
                <strong>
                  <MoneyDisplay>
                    {costPerCompletion - roundUpToNearestCent(revenueSplit * costPerCompletion)}
                  </MoneyDisplay>
                </strong>
              </td>
            </tr>
          </SortableTable>
        </Card>
        <br />
        <br />
        <Card style={{opacity:useCostPerCompletion ? 0.5 : 1}}>
          <SortableTable columns={[
            {name:'Activity',width:30},
            {name:'Default',width:10},
            {name:'Special Price',width:20},
            {name:'Consumer Gets',width:20},
            {name:'Dabbl Gets',width:20}
          ]}>
            <tr>
              <td>Multiple Choice</td>
              <td>
                <strong>
                  <MoneyDisplay>{defaultChooseDefaultCost}</MoneyDisplay>
                </strong>
              </td>
              <td>
                <MoneyInput
                  name='choosePrice'
                  value={choosePrice}
                  onChange={(val) => this.setState({choosePrice:val})}
                  required
                  disabled={useCostPerCompletion}
                  readOnly={readOnly}
                />
              </td>
              <td>
                <strong>
                  <MoneyDisplay>
                    {Math.ceil(parseFloat((choosePrice * revenueSplit * 100).toPrecision(12))) / 100}
                  </MoneyDisplay>
                </strong>
              </td>
              <td>
                <strong>
                  <MoneyDisplay>
                    {choosePrice - Math.ceil(parseFloat((choosePrice * revenueSplit * 100).toPrecision(12))) / 100}
                  </MoneyDisplay>
                </strong>
              </td>
            </tr>
            <tr>
              <td>This or That</td>
              <td>
                <strong>
                  <MoneyDisplay>{defaultThisOrThatDefaultCost}</MoneyDisplay>
                </strong>
              </td>
              <td>
                <MoneyInput
                  name='thisOrThatPrice'
                  value={thisOrThatPrice}
                  onChange={(val) => this.setState({thisOrThatPrice:val})}
                  required
                  disabled={useCostPerCompletion}
                  readOnly={readOnly}
                />
              </td>
              <td>
                <strong>
                  <MoneyDisplay>
                    {Math.ceil(parseFloat((thisOrThatPrice*revenueSplit * 100).toPrecision(12))) / 100}
                  </MoneyDisplay>
                </strong>
              </td>
              <td>
                <strong>
                  <MoneyDisplay>
                    {thisOrThatPrice - Math.ceil(parseFloat((thisOrThatPrice*revenueSplit * 100).toPrecision(12))) / 100}
                  </MoneyDisplay>
                </strong>
              </td>
            </tr>
            <tr>
              <td>Video</td>
              <td>
                <strong>
                  <MoneyDisplay>{defaultRatableDefaultCost}</MoneyDisplay>
                </strong>
              </td>
              <td>
                <MoneyInput
                  name='ratablePrice'
                  value={ratablePrice}
                  onChange={(val) => this.setState({ratablePrice:val})}
                  disabled={useCostPerCompletion}
                  readOnly={readOnly}
                />
              </td>
              <td>
                <strong>
                  <MoneyDisplay>
                    {Math.ceil(parseFloat((ratablePrice*revenueSplit * 100).toPrecision(12))) / 100}
                  </MoneyDisplay>
                </strong>
              </td>
              <td>
                <strong>
                  <MoneyDisplay>
                    {ratablePrice - Math.ceil(parseFloat((ratablePrice*revenueSplit * 100).toPrecision(12))) / 100}
                  </MoneyDisplay>
                </strong>
              </td>
            </tr>
            <tr>
              <td>Trivia</td>
              <td>
                <strong>
                  <MoneyDisplay>{defaultQADefaultCost}</MoneyDisplay>
                </strong>
              </td>
              <td>
                <MoneyInput
                  name='qaPrice'
                  value={qaPrice}
                  onChange={(val) => this.setState({qaPrice:val})}
                  disabled={useCostPerCompletion}
                  readOnly={readOnly}
                />
              </td>
              <td>
                <strong>
                  <MoneyDisplay>
                    {Math.ceil(parseFloat((qaPrice * revenueSplit * 100).toPrecision(12))) / 100}
                  </MoneyDisplay>
                </strong>
              </td>
              <td>
                <strong>
                  <MoneyDisplay>
                    {qaPrice - Math.ceil(parseFloat((qaPrice * revenueSplit * 100).toPrecision(12))) / 100}
                  </MoneyDisplay>
                </strong>
              </td>
            </tr>
          </SortableTable>
        </Card>
        {readOnly ? (
          <div className='pull-right'>
            <small>{readOnlyMessage || 'Special pricing is not editable'}</small>
          </div>
        ) : (
          <div>
            <Button isSubmit>
              {updateButtonText}
            </Button>
            {allowPropagation && (
              <span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <Label check>
                  <Input type='checkbox' name='propagateCostChanges' />
                  &nbsp;&nbsp;{propagationCheckboxText}
                </Label>
              </span>
            )}
          </div>
        )}
      </Form>
    )
  }
}

SpecialPricingForm.defaultProps = {
  forceUpdate:false,
  defaultRevenueSplit:ADJOY_DEFAULT_REVENUE_SPLIT,
  ratableDefaultCost:ADJOY_DEFAULT_RATABLE_COST,
  chooseDefaultCost:ADJOY_DEFAULT_CHOOSE_COST,
  thisOrThatDefaultCost:ADJOY_DEFAULT_THIS_OR_THAT_COST,
  updateButtonText:'Update',
  onChange:() => {},
  onSubmit:() => {},
  readOnly:false,
  allowPropagation:false,
  propagationCheckboxText:'Propagate to children'
};

SpecialPricingForm.propTypes = {
  forceUpdate:PropTypes.bool,
  defaultRevenueSplit:PropTypes.number,
  chooseDefaultCost:PropTypes.number,
  ratableDefaultCost:PropTypes.number,
  thisOrThatDefaultCost:PropTypes.number,
  updateButtonText:PropTypes.string,
  onChange:PropTypes.func,
  onSubmit:PropTypes.func,
  readOnly:PropTypes.bool.isRequired,
  readOnlyMessage:PropTypes.string,
  allowPropagation:PropTypes.bool,
  propagationCheckboxText:PropTypes.string
};

export default SpecialPricingForm;



// WEBPACK FOOTER //
// ./src/shared/components/SpecialPricingForm/SpecialPricingForm.js